import { HeaderConfigSnapshot } from '../contracts/header';

export const DEFAULT_HEADER_CONFIG: HeaderConfigSnapshot = {
  schemaVersion: 1,
  releaseId: 'default-v1.0.0',
  environment: 'production',
  locale: 'en-US',
  publishedAt: new Date().toISOString(),
  variants: {
    full: [
      { id: 'explore', label: 'Explore', href: 'https://www.vidau.ai/explore' },
      { id: 'divider-explore', label: '|', href: '' },
      { 
        id: 'image', 
        label: 'Image', 
        href: 'https://www.vidau.ai/image',
        children: [
          {
            id: 'features-group',
            label: 'Features',
            href: '',
            children: [
               { id: 'text-to-image', label: 'Text to Image', description: 'Generate AI images from text', icon: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7V4h16v3M9 20h6M12 4v16"/></svg>', href: '/image/text-to-image' },
               { id: 'image-to-image', label: 'Image to Image', description: 'Transform images with AI', icon: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>', href: '/image/image-to-image' }
            ]
          },
          {
            id: 'models-group',
            label: 'Models',
            href: '',
            children: [
               { id: 'gpt-image-2', label: 'GPT Image 2', description: 'Redefine the limits of design', icon: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/><path d="M2 12h20"/></svg>', href: '/image/gpt2', badge: 'Top' },
               { id: 'nano-banana-2', label: 'Nano Banana 2', description: 'Better, cheaper and faster', icon: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5.5 8.5C5.5 8.5 7 7 8 8C9 9 9.5 10 10.5 9.5C11.5 9 12 7 13 8C14 9 14.5 10 15.5 9.5C16.5 9 18 7.5 18.5 8.5C19 9.5 18 12.5 16.5 15.5C15 18.5 11.5 20.5 8.5 20C5.5 19.5 4 17 3.5 14C3 11 5 9.5 5.5 8.5Z"/></svg>', href: '/image/nano2', badge: 'Top' },
               { id: 'seedream-5', label: 'Seedream 5.0', description: 'Imagination perfectly understood', icon: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 20V10M12 20V4M6 20v-6"/></svg>', href: '/image/seedream' },
               { id: 'nano-banana-pro', label: 'Nano Banana Pro', description: 'Precision that never misses', icon: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5.5 8.5C5.5 8.5 7 7 8 8C9 9 9.5 10 10.5 9.5C11.5 9 12 7 13 8C14 9 14.5 10 15.5 9.5C16.5 9 18 7.5 18.5 8.5C19 9.5 18 12.5 16.5 15.5C15 18.5 11.5 20.5 8.5 20C5.5 19.5 4 17 3.5 14C3 11 5 9.5 5.5 8.5Z"/></svg>', href: '/image/nanopro' }
            ]
          }
        ]
      },
      { id: 'video', label: 'Video', href: 'https://www.vidau.ai/video' },
      { id: 'creative-studio', label: 'Creative Studio', href: 'https://www.vidau.ai/studio' },
      { id: 'divider-studio', label: '|', href: '' },
      { id: 'crew', label: 'Crew', href: 'https://www.vidau.ai/crew', badge: 'New' },
      { id: 'creative-agent', label: 'Creative Agent', href: 'https://www.vidau.ai/agent', badge: 'New' },
      { id: 'paid-media', label: 'Paid Media', href: 'https://www.vidau.ai/paid-media' },
      { id: 'download', label: 'Download', href: 'https://www.vidau.ai/download' },
      { id: 'mcp-cli', label: 'MCP & CLI', href: 'https://www.vidau.ai/docs/mcp', badge: 'New' },
      { id: 'api', label: 'API', href: 'https://www.vidau.ai/api' }
    ],
    compact: [
      { id: 'explore', label: 'Explore', href: 'https://www.vidau.ai/explore' }
    ]
  },
  authUi: {
    registrationEnabled: true,
    providers: ['google', 'apple', 'email']
  }
};
